/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TeacherZoneRouteImport } from './routes/teacher-zone'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as ArticlesRouteImport } from './routes/articles'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArticlesIndexRouteImport } from './routes/articles.index'
import { Route as BooksSearchRouteImport } from './routes/books.search'
import { Route as BooksBookOfTheMonthRouteImport } from './routes/books.book-of-the-month'
import { Route as BooksSlugRouteImport } from './routes/books.$slug'
import { Route as ArticlesSlugRouteImport } from './routes/articles.$slug'
import { Route as BooksQuizResultsSlugRouteImport } from './routes/books.quiz-results.$slug'
import { Route as ArticlesQuizResultsSlugRouteImport } from './routes/articles.quiz-results.$slug'

const TeacherZoneRoute = TeacherZoneRouteImport.update({
  id: '/teacher-zone',
  path: '/teacher-zone',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesRoute = ArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArticlesRoute,
} as any)
const BooksSearchRoute = BooksSearchRouteImport.update({
  id: '/books/search',
  path: '/books/search',
  getParentRoute: () => rootRouteImport,
} as any)
const BooksBookOfTheMonthRoute = BooksBookOfTheMonthRouteImport.update({
  id: '/books/book-of-the-month',
  path: '/books/book-of-the-month',
  getParentRoute: () => rootRouteImport,
} as any)
const BooksSlugRoute = BooksSlugRouteImport.update({
  id: '/books/$slug',
  path: '/books/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ArticlesRoute,
} as any)
const BooksQuizResultsSlugRoute = BooksQuizResultsSlugRouteImport.update({
  id: '/books/quiz-results/$slug',
  path: '/books/quiz-results/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesQuizResultsSlugRoute = ArticlesQuizResultsSlugRouteImport.update({
  id: '/quiz-results/$slug',
  path: '/quiz-results/$slug',
  getParentRoute: () => ArticlesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/articles': typeof ArticlesRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/dashboard': typeof DashboardRoute
  '/leaderboard': typeof LeaderboardRoute
  '/maintenance': typeof MaintenanceRoute
  '/profile': typeof ProfileRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/teacher-zone': typeof TeacherZoneRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/books/$slug': typeof BooksSlugRoute
  '/books/book-of-the-month': typeof BooksBookOfTheMonthRoute
  '/books/search': typeof BooksSearchRoute
  '/articles/': typeof ArticlesIndexRoute
  '/articles/quiz-results/$slug': typeof ArticlesQuizResultsSlugRoute
  '/books/quiz-results/$slug': typeof BooksQuizResultsSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/dashboard': typeof DashboardRoute
  '/leaderboard': typeof LeaderboardRoute
  '/maintenance': typeof MaintenanceRoute
  '/profile': typeof ProfileRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/teacher-zone': typeof TeacherZoneRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/books/$slug': typeof BooksSlugRoute
  '/books/book-of-the-month': typeof BooksBookOfTheMonthRoute
  '/books/search': typeof BooksSearchRoute
  '/articles': typeof ArticlesIndexRoute
  '/articles/quiz-results/$slug': typeof ArticlesQuizResultsSlugRoute
  '/books/quiz-results/$slug': typeof BooksQuizResultsSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/articles': typeof ArticlesRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/dashboard': typeof DashboardRoute
  '/leaderboard': typeof LeaderboardRoute
  '/maintenance': typeof MaintenanceRoute
  '/profile': typeof ProfileRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/teacher-zone': typeof TeacherZoneRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/books/$slug': typeof BooksSlugRoute
  '/books/book-of-the-month': typeof BooksBookOfTheMonthRoute
  '/books/search': typeof BooksSearchRoute
  '/articles/': typeof ArticlesIndexRoute
  '/articles/quiz-results/$slug': typeof ArticlesQuizResultsSlugRoute
  '/books/quiz-results/$slug': typeof BooksQuizResultsSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/articles'
    | '/complete-profile'
    | '/dashboard'
    | '/leaderboard'
    | '/maintenance'
    | '/profile'
    | '/sign-in'
    | '/sign-up'
    | '/teacher-zone'
    | '/articles/$slug'
    | '/books/$slug'
    | '/books/book-of-the-month'
    | '/books/search'
    | '/articles/'
    | '/articles/quiz-results/$slug'
    | '/books/quiz-results/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/complete-profile'
    | '/dashboard'
    | '/leaderboard'
    | '/maintenance'
    | '/profile'
    | '/sign-in'
    | '/sign-up'
    | '/teacher-zone'
    | '/articles/$slug'
    | '/books/$slug'
    | '/books/book-of-the-month'
    | '/books/search'
    | '/articles'
    | '/articles/quiz-results/$slug'
    | '/books/quiz-results/$slug'
  id:
    | '__root__'
    | '/'
    | '/articles'
    | '/complete-profile'
    | '/dashboard'
    | '/leaderboard'
    | '/maintenance'
    | '/profile'
    | '/sign-in'
    | '/sign-up'
    | '/teacher-zone'
    | '/articles/$slug'
    | '/books/$slug'
    | '/books/book-of-the-month'
    | '/books/search'
    | '/articles/'
    | '/articles/quiz-results/$slug'
    | '/books/quiz-results/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArticlesRoute: typeof ArticlesRouteWithChildren
  CompleteProfileRoute: typeof CompleteProfileRoute
  DashboardRoute: typeof DashboardRoute
  LeaderboardRoute: typeof LeaderboardRoute
  MaintenanceRoute: typeof MaintenanceRoute
  ProfileRoute: typeof ProfileRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  TeacherZoneRoute: typeof TeacherZoneRoute
  BooksSlugRoute: typeof BooksSlugRoute
  BooksBookOfTheMonthRoute: typeof BooksBookOfTheMonthRoute
  BooksSearchRoute: typeof BooksSearchRoute
  BooksQuizResultsSlugRoute: typeof BooksQuizResultsSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/teacher-zone': {
      id: '/teacher-zone'
      path: '/teacher-zone'
      fullPath: '/teacher-zone'
      preLoaderRoute: typeof TeacherZoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles': {
      id: '/articles'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof ArticlesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/': {
      id: '/articles/'
      path: '/'
      fullPath: '/articles/'
      preLoaderRoute: typeof ArticlesIndexRouteImport
      parentRoute: typeof ArticlesRoute
    }
    '/books/search': {
      id: '/books/search'
      path: '/books/search'
      fullPath: '/books/search'
      preLoaderRoute: typeof BooksSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/books/book-of-the-month': {
      id: '/books/book-of-the-month'
      path: '/books/book-of-the-month'
      fullPath: '/books/book-of-the-month'
      preLoaderRoute: typeof BooksBookOfTheMonthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/books/$slug': {
      id: '/books/$slug'
      path: '/books/$slug'
      fullPath: '/books/$slug'
      preLoaderRoute: typeof BooksSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$slug': {
      id: '/articles/$slug'
      path: '/$slug'
      fullPath: '/articles/$slug'
      preLoaderRoute: typeof ArticlesSlugRouteImport
      parentRoute: typeof ArticlesRoute
    }
    '/books/quiz-results/$slug': {
      id: '/books/quiz-results/$slug'
      path: '/books/quiz-results/$slug'
      fullPath: '/books/quiz-results/$slug'
      preLoaderRoute: typeof BooksQuizResultsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/quiz-results/$slug': {
      id: '/articles/quiz-results/$slug'
      path: '/quiz-results/$slug'
      fullPath: '/articles/quiz-results/$slug'
      preLoaderRoute: typeof ArticlesQuizResultsSlugRouteImport
      parentRoute: typeof ArticlesRoute
    }
  }
}

interface ArticlesRouteChildren {
  ArticlesSlugRoute: typeof ArticlesSlugRoute
  ArticlesIndexRoute: typeof ArticlesIndexRoute
  ArticlesQuizResultsSlugRoute: typeof ArticlesQuizResultsSlugRoute
}

const ArticlesRouteChildren: ArticlesRouteChildren = {
  ArticlesSlugRoute: ArticlesSlugRoute,
  ArticlesIndexRoute: ArticlesIndexRoute,
  ArticlesQuizResultsSlugRoute: ArticlesQuizResultsSlugRoute,
}

const ArticlesRouteWithChildren = ArticlesRoute._addFileChildren(
  ArticlesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArticlesRoute: ArticlesRouteWithChildren,
  CompleteProfileRoute: CompleteProfileRoute,
  DashboardRoute: DashboardRoute,
  LeaderboardRoute: LeaderboardRoute,
  MaintenanceRoute: MaintenanceRoute,
  ProfileRoute: ProfileRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TeacherZoneRoute: TeacherZoneRoute,
  BooksSlugRoute: BooksSlugRoute,
  BooksBookOfTheMonthRoute: BooksBookOfTheMonthRoute,
  BooksSearchRoute: BooksSearchRoute,
  BooksQuizResultsSlugRoute: BooksQuizResultsSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
